import {
  VIEW_CANDIDATE,VIEW_CANDIDATE_ERROR, VIEW_CANDIDATE_SUCCESS
, MATCHING_JOBS,MATCHING_JOBS_ERROR,MATCHING_JOBS_SUCCESS,
JOB_DETAIL,JOB_DETAIL_SUCCESS,JOB_DETAIL_ERROR,
SIMILAR_CADNIDATE,SIMILAR_CADNIDATE_ERROR,SIMILAR_CADNIDATE_SUCCESS,
CADNIDATE_DETAIL,CADNIDATE_DETAIL_ERROR,CADNIDATE_DETAIL_SUCCESS,
CANDIDATE_JOB_MAPPING,CANDIDATE_JOB_MAPPING_SUCCESS,CANDIDATE_JOB_MAPPING_ERROR,
GET_CANDIDATE_JOB_MAPPING,GET_CANDIDATE_JOB_MAPPING_ERROR,GET_CANDIDATE_JOB_MAPPING_SUCCESS,
DELETE_CANDIDATE_JOB_MAPPING,DELETE_CANDIDATE_JOB_MAPPING_SUCCESS,DELETE_CANDIDATE_JOB_MAPPING_ERROR,
GET_CANDIDATE_ACTIVE_LOG,GET_CANDIDATE_ACTIVE_LOG_SUCCESS,GET_CANDIDATE_ACTIVE_LOG_ERROR
} from './actionTypes';

export const getCandidateDetails = candidate => {
    return {
      type: VIEW_CANDIDATE,
      payload: { candidate },
    }
  }
export const getCandidateDetailsFailed = candidate => {
    return {
      type: VIEW_CANDIDATE_ERROR,
      payload: { candidate },
    }
  }
export const getCandidateDetailsSuccess = candidate => {
    return {
      type: VIEW_CANDIDATE_SUCCESS,
      payload: { candidate },
    }
  }
//MATCHING JOBS 
export const getMatchingJobDetails = matchingJob => {
  return {
    type: MATCHING_JOBS,
    payload: { matchingJob },
  }
}
export const getMatchingJobSuccess = matchingJob => {
  return {
    type: MATCHING_JOBS_SUCCESS,
    payload: { matchingJob },
  }
}
export const getMatchingJobError = matchingJob => {
  return {
    type: MATCHING_JOBS_ERROR,
    payload: { matchingJob },
  }
}
// JOB DETAILS 
export const getJobDetails = jobDetail => {
  return {
    type: JOB_DETAIL,
    payload: { jobDetail },
  }
}
export const getJobDetailsSuccess = jobDetail => {
  return {
    type: JOB_DETAIL_SUCCESS,
    payload: { jobDetail },
  }
}
export const getJobDetailsError = jobDetail => {
  return {
    type: JOB_DETAIL_ERROR,
    payload: { jobDetail },
  }
}

// SIMILAR CANDIDATE 
export const getSimilarCandidate = (similarCandidate,page) => {
  return {
    type: SIMILAR_CADNIDATE,
    payload: { similarCandidate ,page},
  }
}
export const getSimilarCandidateSuccess = similarCandidate => {
  return {
    type: SIMILAR_CADNIDATE_SUCCESS,
    payload: { similarCandidate },
  }
}
export const getSimilarCandidatesError = similarCandidate => {
  return {
    type: SIMILAR_CADNIDATE_ERROR,
    payload: { similarCandidate },
  }
}
//CANDIDATE DDETAIL 
export const getSimilarCandidateDetail = clickedCandidate => {
  return {
    type: CADNIDATE_DETAIL,
    payload: { clickedCandidate },
  }
}
export const getSimilarCandidateDetailSuccess = clickedCandidate => {
  return {
    type: CADNIDATE_DETAIL_SUCCESS,
    payload: { clickedCandidate },
  }
}
export const getSimilarCandidateDetailError = clickedCandidate => {
  return {
    type: CADNIDATE_DETAIL_ERROR,
    payload: { clickedCandidate },
  }
}
//SET CANDIDATE JOB DETAIL 
export const getCandidateJobMapping = candidateJob => {
  return {
    type: CANDIDATE_JOB_MAPPING,
    payload: { candidateJob },
  }
}
export const getCandidateJobMappingSuccess = candidateJob => {
  return {
    type: CANDIDATE_JOB_MAPPING_SUCCESS,
    payload: { candidateJob },
  }
}
export const getCandidateJobMappingError = candidateJob => {
  return {
    type: CANDIDATE_JOB_MAPPING_ERROR,
    payload: { candidateJob },
  }
}
//GET CANDIDATE JOB DETAIL 
export const getCandidateJobMappingDetail = getcandidateJob => {
  return {
    type: GET_CANDIDATE_JOB_MAPPING,
    payload: { getcandidateJob },
  }
}
export const getCandidateJobMappingDetailSuccess = getcandidateJob => {
  return {
    type: GET_CANDIDATE_JOB_MAPPING_SUCCESS,
    payload: { getcandidateJob },
  }
}
export const getCandidateJobMappingDetailError = getcandidateJob => {
  return {
    type: GET_CANDIDATE_JOB_MAPPING_ERROR,
    payload: { getcandidateJob },
  }
}
//DELETE CANDIDATE JOB DETAIL 
export const deleteCandidateJobMap = deletecandidateJob => {
  return {
    type: DELETE_CANDIDATE_JOB_MAPPING,
    payload: { deletecandidateJob },
  }
}
export const deleteCandidateJobMapSuccess = deletecandidateJob => {
  return {
    type: DELETE_CANDIDATE_JOB_MAPPING_SUCCESS,
    payload: { deletecandidateJob },
  }
}
export const deleteCandidateJobMapError = deletecandidateJob => {
  return {
    type: DELETE_CANDIDATE_JOB_MAPPING_ERROR,
    payload: { deletecandidateJob },
  }
}

//Candidate active log
export const getCandidateActiveLog = data => {
  return {
    type: GET_CANDIDATE_ACTIVE_LOG,
    payload: {data},
  }
}
export const getCandidateActiveLogSuccess = data => {
  return {
    type: GET_CANDIDATE_ACTIVE_LOG_SUCCESS,
    payload: { data},
  }
}
export const getCandidateActiveLogFail = data => {
  return {
    type: GET_CANDIDATE_ACTIVE_LOG_ERROR,
    payload: { data},
  }
}